export { default } from './Medal';
